import type { FaireProductEntity } from "../../entity_types/product";

export const viverano_19: FaireProductEntity = {
  token: "viverano-19",
  type: "product",
  name: "Horse & Bird Button Baby Flare Dress+ Bloomer Set(Organic)",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/ff81f0c68bace512116f8cce6aec8073512267fb9c117d4375b58b3d22780cad.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 30,
  msrpDollars: 52,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
